module.exports = __webpack_public_path__ + "static/media/globe.83f4be21.gif";